<template>
  <ion-page>
    <ion-content :class="'main-background'" :fullscreen="true" :scroll-y="false">
      <div class="logo">
        <img src="@/theme/liga-logo-white.png" alt="liga-logo">
      </div>
      <ion-card class="bg-transparent">
        <ion-card-header class="ion-text-center white-bold">ОТСУТСТВУЕТ СОЕДИНЕНИЕ</ion-card-header>
        <ion-card-content>
          <div class="main-button-container" ref="refreshIconRef">
            <ion-button v-on:click="reconnect()" :disabled="reconnecting">
              <ion-icon slot="icon-only" :icon="refreshOutline" v-show="!reconnecting"></ion-icon>
              <ion-spinner name="bubbles" v-show="reconnecting"></ion-spinner>
            </ion-button>

            <ion-button v-on:click="setOfflineMode()" class="offline-button" v-if="isMobile">
              ОФФЛАЙН
            </ion-button>
          </div>
        </ion-card-content>
      </ion-card>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { GlobalContext } from '@/model/globalcontext.model';
import FilesystemCustomUtils from '@/services/filesystem.custom.utils';
import { CapacitorHttp } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonContent,
    IonIcon,
    IonPage,
    IonSpinner,
} from '@ionic/vue';
import axios from 'axios';
import { refreshOutline } from 'ionicons/icons';
import { defineComponent, inject } from 'vue';

export default defineComponent({
  props: {
    timeout: { type: Number, default: 1000 },
  },
  name: 'BadConnection',
  components: {
    IonContent,
    IonPage,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonButton,
    IonIcon,
    IonSpinner,
  },
  setup() {
    const globalContext = inject('globalContext') as GlobalContext;
    const isMobile = globalContext.isMobile;

    return {
      refreshOutline,
      globalContext,
      isMobile,
    }
  },
  data() {
    return {
      reconnecting: false,
      retryTotal: 5,
      retryNum: 0,
    }
  },

  ionViewDidEnter() {
    this.reconnect(10);
  },

  methods: {
    reconnect(retry?: number) {
      this.reconnecting = true;
      for (let i = 0; i < (retry ? retry : 1); i++) {
        setTimeout(async () => {
          if (this.isMobile) {
            const tokenQuery = await Preferences.get({ key: 'jwt' });
            const token = tokenQuery.value;

            CapacitorHttp.request({
              method: 'GET',
              url: `${process.env.VUE_APP_API_URL}api/test-connection`,
              headers: { Authorization: `Bearer ${token}` }
            }).then(() => {
              this.globalContext.offlineMode = false;
              this.$router.replace("today");
            }).catch(err => {
              if (err.message === 'Network Error') {
                this.$router.replace('/badconnection');
              }
            }).finally(() => {
              this.reconnecting = false;
            })
          } else {
            axios.get('api/test-connection')
              .then(() => {
                this.globalContext.offlineMode = false;
                this.$router.replace("today");
              }).catch(err => {
                if (err.message === 'Network Error') {
                  this.$router.replace('/badconnection');
                }
              }).finally(() => {
                this.reconnecting = false;
              });
          }
        }, 3000);
      }
    },

    setOfflineMode() {
      Preferences.get({ key: 'jwt' }).then((checkJwt) => {
        if (checkJwt.value && checkJwt.value.length > 0) {
          this.globalContext.offlineMode = true;
          const fs = new FilesystemCustomUtils();
          void fs.hasAnyLibraryMusicOffline().then((has) => {
            this.globalContext.hasOfflineLibraryMusic = has;
          });
          this.$router.replace('/today');
        }
      })
    },
  }
});
</script>

<style scoped>
.logo {
  margin: 10vh 0 -6vh 0;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  min-height: 80px;
}

.logo img {
  width: 300px;
}

ion-card {
  box-shadow: none;
}

ion-card-header {
  letter-spacing: .08em;
  font-size: 2em;
}

ion-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  width: 280px;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
}

.main-button-container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.offline-button {
  margin-top: 5vh;
  width: 50vw !important;
}
</style>